module.exports = __webpack_public_path__ + "static/media/5.Internet-things-pictures.6b58a2aa.png";